import { registerViewMount } from './navigation.js';
import { appendTrustedAdminViewFragment } from './trusted-admin-view-fragment.js';

let productResearchAlertMountPromise = null;

export function initProductResearchAlertViewFragment({ onMounted } = {}) {
  registerViewMount('admin-product-research-alert', () => mountProductResearchAlertView(onMounted));
}

async function mountProductResearchAlertView(onMounted) {
  if (document.getElementById('view-admin-product-research-alert')) return;
  if (productResearchAlertMountPromise) return productResearchAlertMountPromise;

  productResearchAlertMountPromise = (async () => {
    const host = document.getElementById('admin-lazy-view-host');
    if (!host) throw new Error('Admin lazy view host is unavailable');

    await appendTrustedAdminViewFragment(host, '/admin-views/product-research-alert.html', 'Unable to load product research alert view');
    onMounted?.();
  })();

  try {
    await productResearchAlertMountPromise;
  } catch (error) {
    productResearchAlertMountPromise = null;
    throw error;
  }
}
